/* swatches.js - optimized instant add & smooth drawer */

(function(){
  const FREE_LIMIT = 5;
  const ROOT_ID = 'swatch-cart-drawer-root';
  const BTN = '.btn-add-swatch';

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    return r.json();
  }

  async function addVariant(variantId, quantity = 1, props = {}) {
    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', quantity);
    for (const k in props) body.append(`properties[${k}]`, props[k]);
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body, keepalive: true })
      .then(r => r.json());
  }

  async function changeCart(payload) {
    const body = new FormData();
    for (const k in payload) body.append(k, payload[k]);
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', body }).then(r => r.json());
  }

  function countSwatches(cart){
    return cart.items.filter(i=>i.properties && i.properties.swatch=='true')
                     .reduce((a,b)=>a+b.quantity,0);
  }

  function buildVariantMap(){
    const map={paidToFree:{},all:[]};
    document.querySelectorAll('.swatch-card').forEach(c=>{
      const free=parseInt(c.dataset.freeVariant);
      const paid=parseInt(c.dataset.paidVariant);
      const title=c.dataset.productTitle;
      const img=c.querySelector('img')?.src || '';
      if(free&&paid) map.paidToFree[paid]=free;
      map.all.push({free,paid,title,img});
    });
    return map;
  }

  const variantMap=buildVariantMap();

  function formatMoney(c){return `$${(c/100).toFixed(2)}`;}

  function renderDrawer(cart){
    const root=document.getElementById(ROOT_ID);
    if(!root) return;

    const overlay=document.createElement('div');
    overlay.id='drawer-overlay';
    overlay.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,0.3);z-index:99998;opacity:0;transition:opacity .3s;';
    
    let html=`<div id="swatch-drawer" style="
      position:fixed;top:0;right:-400px;height:100vh;width:360px;
      background:#fff;box-shadow:-6px 0 25px rgba(0,0,0,0.15);
      z-index:99999;padding:18px;overflow:auto;transition:transform .35s ease, right .35s ease;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
        <h3 style="margin:0">Cart</h3>
        <button id="swatch-drawer-close" style="background:none;border:none;font-size:20px;cursor:pointer;">✕</button>
      </div>
      <div id="drawer-items" style="display:flex;flex-direction:column;gap:10px;">`;

    const items=cart.items.filter(i=>i.properties?.swatch=='true');
    if(!items.length) html+=`<p style="color:#666;padding:10px;">No swatches yet.</p>`;
    else items.forEach(it=>{
      html+=`
      <div style="display:flex;gap:10px;border-bottom:1px solid #eee;padding:8px 0;">
        <img src="${it.image||''}" style="width:60px;height:60px;object-fit:cover;border-radius:5px;">
        <div style="flex:1;">
          <div style="font-weight:600;">${it.product_title}</div>
          <div style="font-size:13px;color:#777;">${it.properties['Sample Type']}</div>
          <div style="color:#d24e3b;font-weight:700;">${formatMoney(it.final_line_price)}</div>
        </div>
        <button class="drawer-remove" data-variant="${it.variant_id}" style="background:none;border:none;cursor:pointer;font-size:18px;">🗑️</button>
      </div>`;
    });

    html+=`</div>
      <div style="border-top:1px solid #ddd;margin-top:15px;padding-top:10px;display:flex;justify-content:space-between;">
        <strong>Total</strong><span>${formatMoney(cart.items_subtotal_price)}</span>
      </div>
      <div style="margin-top:15px;display:flex;gap:8px;">
        <a href="/cart" style="flex:1;text-align:center;padding:10px;background:#153b57;color:#fff;border-radius:6px;text-decoration:none;">View Cart</a>
        <a href="/checkout" style="flex:1;text-align:center;padding:10px;background:#d24e3b;color:#fff;border-radius:6px;text-decoration:none;">Checkout</a>
      </div>
    </div>`;

    root.innerHTML='';
    root.appendChild(overlay);
    root.insertAdjacentHTML('beforeend', html);

    const drawer=root.querySelector('#swatch-drawer');
    requestAnimationFrame(()=>{
      overlay.style.opacity='1';
      drawer.style.right='0';
    });

    // close events
    overlay.onclick=()=>closeDrawer();
    document.getElementById('swatch-drawer-close').onclick=()=>closeDrawer();

    // remove item
    root.querySelectorAll('.drawer-remove').forEach(btn=>{
      btn.onclick=async()=>{
        const cartObj=await getCart();
        const line=cartObj.items.findIndex(i=>i.variant_id==btn.dataset.variant)+1;
        if(line){await changeCart({line,quantity:0});const nc=await getCart();renderDrawer(nc);}
      };
    });

    // prevent background scroll
    document.body.style.overflow='hidden';
  }

  function closeDrawer(){
    const overlay=document.getElementById('drawer-overlay');
    const drawer=document.getElementById('swatch-drawer');
    if(drawer) drawer.style.right='-400px';
    if(overlay) overlay.style.opacity='0';
    setTimeout(()=>{
      const root=document.getElementById(ROOT_ID);
      if(root) root.innerHTML='';
      document.body.style.overflow='';
    },300);
  }

  async function postAddAdjustments(){
    const cart=await getCart();
    const sw=countSwatches(cart);
    if(sw<=FREE_LIMIT){
      for(let i=0;i<cart.items.length;i++){
        const it=cart.items[i];
        if(it.properties?.swatch=='true' && it.properties['Sample Type']=='Paid'){
          const freeId=variantMap.paidToFree[it.variant_id];
          if(freeId) await changeCart({line:i+1,id:freeId});
        }
      }
    }
  }

  function updateHeader(cart){
    const h=document.querySelector('.fabric-swatches-page p');
    if(h) h.textContent=`⚠️ Free swatches used: ${Math.min(countSwatches(cart),FREE_LIMIT)} / ${FREE_LIMIT}. From ${FREE_LIMIT+1}th onwards $5 per swatch applies.`;
  }

  async function onAddClick(e){
    const btn=e.currentTarget;
    const card=btn.closest('.swatch-card');
    const free=parseInt(card.dataset.freeVariant);
    const paid=parseInt(card.dataset.paidVariant);
    btn.disabled=true;

    const cart=await getCart();
    const total=countSwatches(cart);
    let vid=free; let type='Free';
    if(total>=FREE_LIMIT){vid=paid||free;type='Paid';}

    // instant UI feedback
    btn.textContent='Added ✓';
    btn.style.background='#228b22';

    await addVariant(vid,1,{swatch:'true','Sample Type':type});
    await postAddAdjustments();
    const nc=await getCart();
    updateHeader(nc);
    renderDrawer(nc);

    setTimeout(()=>{
      btn.textContent='Add to Cart';
      btn.style.background='#1f6f4a';
      btn.disabled=false;
    },1200);
  }

  async function init(){
    document.querySelectorAll(BTN).forEach(b=>b.onclick=onAddClick);
    const c=await getCart();
    updateHeader(c);
  }

  document.addEventListener('DOMContentLoaded',init);
})();
